import GraphqlError from '~/components/GraphqlError';
import LoadingArea from '~/components/LoadingArea';

export default function FormWrapper({ children, loading, error, refetch }) {
  return (
    <form
      className="flex flex-col h-full overflow-y-scroll flex-nowrap"
      style={{ width: '850px' }}>
      {loading ? (
        <LoadingArea loading />
      ) : error ? (
        <GraphqlError error={error} refetch={refetch} loading={loading} />
      ) : children ? (
        children()
      ) : null}
    </form>
  );
}

FormWrapper.propTypes = {
  children: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.object,
  refetch: PropTypes.func,
};
